import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ShoppingCartIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/content";
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const check = () => {
      const anchor = document.getElementById("first-cta");
      if (!anchor) return;
      setVisible(anchor.getBoundingClientRect().bottom < 0);
    };
    check();
    window.addEventListener("scroll", check, {
      passive: true
    });
    window.addEventListener("resize", check);
    return () => {
      window.removeEventListener("scroll", check);
      window.removeEventListener("resize", check);
    };
  }, []);
  return <AnimatePresence data-id="element-32" data-mp="bq9fgqvr9a0r">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3 pt-2 sm:px-0 sm:pb-5 sm:pt-0 pointer-events-none" data-id="element-33" data-mp="195wszeeohtah">
          <a href={CHECKOUT_URL} className="pointer-events-auto animate-cta-shake mx-auto flex w-full max-w-md items-center justify-center gap-2.5 rounded-2xl border-b-4 border-cta-dark bg-cta px-5 py-4 text-center text-base sm:text-lg font-extrabold uppercase tracking-wide text-white shadow-[0_12px_30px_-6px_rgba(22,163,74,0.7)] focus:outline-none focus-visible:ring-4 focus-visible:ring-cta/40" data-id="element-34" data-mp="2f2zgrjqzd4xd">
            <ShoppingCartIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-35" data-mp="1wbgczap4tmua" />
            <span data-id="element-36" data-mp="1ifcm9rdgvwmk">Get it now for just $27</span>
          </a>
        </motion.div>}
    </AnimatePresence>;
}